import { render, staticRenderFns } from "./DiagramaSetor.vue?vue&type=template&id=107e3422"
import script from "./DiagramaSetor.vue?vue&type=script&lang=js"
export * from "./DiagramaSetor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports